import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldHalved } from '@fortawesome/free-solid-svg-icons';
import { faReact, faDocker, faPython } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "JavaScript",
    "HTML5",
    "SASS",
    "Flask",
    "Python",
    "SQL",
    "PostgreSQL",
    "Postman",
    "Docker",
    "OSINT",
    "Sherlock",
    "Barracuda",
    "Proxmox"
];

const labelsSecond = [
    "Git",
    "GitHub Actions",
    "Docker",
    "Docker Compose",
    "Google Cloud",
    "Azure",
    "Linux",
    "Pandas",
    "Watchtower",
    "Proxmox",
    "Cloudflare",
];

const labelsThird = [
    "Python",
    "PyTorch",
    "Stable-Baselines3",
    "OpenCV",
    "pgvector",
    "AI APIs",
    "OpenAI"
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Competenze</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faShieldHalved} size="3x"/>
                    <h3>Cybersecurity & OSINT</h3>
                    <p>Ho sviluppato applicazioni e tool dedicati alla sicurezza informatica e all’OSINT, con focus su privacy, incident response e automazione. Ho esperienza pratica con analisi di vulnerabilità, gestione policy di sicurezza e sviluppo di web app demo per password manager e strumenti di ricerca OSINT.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x"/>
                    <h3>DevOps & Automation</h3>
                    <p>Realizzo e gestisco pipeline di deployment automatizzato tramite Docker e Docker Compose, con monitoraggio tramite Watchtower e pubblicazione sicura con Cloudflare Tunnel. Mi occupo anche di configurazioni su Proxmox, orchestrazione di servizi containerizzati e gestione di ambienti demo/production-ready.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPython} size="3x"/>
                    <h3>AI & Machine Learning</h3>
                    <p>Sviluppo soluzioni basate su intelligenza artificiale per sicurezza, automazione e ricerca, includendo progetti come sistemi di riconoscimento facciale IoT, matching tra studenti e aziende tramite AI e training di agenti RL in ambienti di gioco.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;